import React from 'react';


const EscalationFunnelChart = ({ data }) => {
  const getStageColor = (index) => {
    const colors = ['bg-error', 'bg-warning', 'bg-accent', 'bg-success'];
    return colors?.[index] || 'bg-muted';
  };

  const getStageIcon = (stage) => {
    const icons = {
      'AI Limitation': 'AlertCircle',
      'Queue Assignment': 'UserPlus',
      'Agent Pickup': 'Phone',
      'Resolution': 'CheckCircle'
    };
    return icons?.[stage] || 'Circle';
  };

  return;



















































};

export default EscalationFunnelChart;